import {AxiosError} from 'axios'
import {Api} from '../../../../api/api'
import {GeneralResponse} from '../../../../helpers/general-response'
import {MasterStockReportResultInterface} from '../interfaces/master-stock-report-result.interface'

export interface GetAllTrxResiReportsParam {
  page?: number
  size?: number
  time_query?: number
  start_time?: number
  end_time?: number
  filters?: string
  sort?: string
}

export const GetAllTrxResiReports = async (
  params: GetAllTrxResiReportsParam
): Promise<MasterStockReportResultInterface> => {
  try {
    const response = await Api.get('/trx-resis-reports', {params: params})

    return response.data as MasterStockReportResultInterface
  } catch (e) {
    const a = e as AxiosError
    const response: MasterStockReportResultInterface = a.response.data
    return response
  }
}

export const GenerateTrxResiReportExcel = async (
  params: GetAllTrxResiReportsParam
): Promise<GeneralResponse> => {
  try {
    const response = await Api.get('/trx-resis-generate-report', {params: params})

    return response.data as GeneralResponse
  } catch (e) {
    const a = e as AxiosError
    const response: GeneralResponse = a.response.data
    return response
  }
}

export const DeleteTrxResiReport = async (id: string): Promise<GeneralResponse> => {
  try {
    const response = await Api.delete('/trx-resis-reports/' + id)
    return response.data as GeneralResponse
  } catch (e) {
    const a = e as AxiosError
    const response: GeneralResponse = a.response?.data
    return response
  }
}
